import * as types from './actionTypes';
// import api from 'api/mock';
import api from 'api/';
import { fileApi } from 'api/';

export function getCities() {
  // body...
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING
    });
    try {
      const citiesGot = await api.getCities();
      let cities = citiesGot.map(city => {
        let cityMap = {
          value: city.name,
          label: city.name
        }
        return cityMap;
      });
      dispatch({
        type: types.LOADED,
        cities
      });
    } catch (error) {
      console.log(error);
    }
  }
}

export function getListicleById(id) {
  // body...
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING
    });
    try {
      const listicle = await api.getListicleById(id);
      dispatch({
        type: types.LOADED,
        listicle
      });
    } catch (error) {
      console.log(error);
    }
  }
}

export function getAllEateryNames(data) {
  // body...
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING
    });
    try {
      const citiesGot = await api.getCities();
      const eateriesGot = await api.getAllEateryNames(data);
      let cities = citiesGot.map(city => {
        let cityMap = {
          value: city.name,
          label: city.name
        }
        return cityMap;
      });
      let eateries = eateriesGot.map(eatery => {
        let eateryMap = {
          value: eatery.title,
          label: eatery.title,
          id: eatery.id,
          image: eatery.imageUrl
        }
        return eateryMap;
      });
      dispatch({
        type: types.LOADED,
        eateries,
        cities
      });
    } catch (error) {
      console.log(error);
    }
  }
}

export function getEatery(id, data) {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: types.LOADING
      });
      const current = await api.getEateryViaId(id);
      const citiesGot = await api.getCities();
      const eateriesGot = await api.getAllEateryNames(data);
      let cities = citiesGot.map(city => {
        let cityMap = {
          value: city.name,
          label: city.name
        }
        return cityMap;
      });
      let eateries = eateriesGot.map(eatery => {
        let eateryMap = {
          value: eatery.title,
          label: eatery.title,
          id: eatery.id,
          image: eatery.imageUrl
        }
        return eateryMap;
      });
      dispatch({
        type: types.LOADED,
        current,
        eateries,
        cities
      });
    } catch (error) {
      console.log(error);
    }
  }
}

export function postFile(file) {
  // body...
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING
    });
    try {
      const fileResp = await fileApi.postMultiple([file]);
      dispatch({
        type: types.LOADED,
        fileResp
      });
    } catch (error) {
      console.log(error);
    }
  }
}

export function postData(data) {
  // body...
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING
    });
    try {
      await api.addListicle(data);
      dispatch({
        type: types.LOADED
      });
    } catch (error) {
      console.log(error);
    }
  }
}

export function updateData(data) {
  // body...
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING
    });
    try {
      await api.updateListicle(data);
      dispatch({
        type: types.LOADED
      });
    } catch (error) {
      console.log(error);
    }
  }
}
